import { Select } from 'antd';
import {
    AudioOutlined,
    CameraOutlined,
    SettingOutlined
} from "@ant-design/icons";
import VoxeetSDK from '@voxeet/voxeet-web-sdk';
import { UserStream } from '../../../widgets/user';
import styles from './auditorium.module.css';
import { upload } from '../../../libs/utils';
import { useRoomStore } from '../../../stores/room';
import { useUserStore } from '../../../stores/user';
import { ReactComponent as SettingsIcon } from '../icons/settings.svg';
import { ReactComponent as ArrowIcon } from '../icons/arrow-left.svg';
import { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router';

const VIEW_MODE = [
    {
        id: 'audience',
        label: 'Audience'
    },
    {
        id: 'presentation',
        label: 'Presentation'
    },
    {
        id: 'seat',
        label: 'Seat Selection'
    }
]

export function AuditoriumRoom(props){
    const navigate = useNavigate();
    const { onOpenSettings, onReady } = props;
    const { id, name, participants, update, locked, members, join, created, spaceId } = useRoomStore();
    const { id: userId } = useUserStore();
    const [mode, setMode] = useState('seat');
    const [ready, setReady] = useState(false);
    const [presentationImage, setPresentationImage] = useState(null);
    const currentParticipant = participants.find(participant => participant.pesuId === userId);
    const hostParticipant = participants.find(participant => participant.pesuId === created.by);
    const seatOnly = mode === 'seat';

    const seats = useMemo(() => {
        const matrix = [];
        for(let i = 0; i < 3; i++){
            const row = [];
            for(let j = 0; j < 5; j++){
                row.push(null);
            }
            matrix.push(row);
        }
        participants.forEach(participant => {
            const member = members && members[participant.pesuId];
            console.log('MARIX', member, matrix);
            if(member && member.pos){
                matrix[member.pos[0]][member.pos[1]] = participant;
            }
        });
        // const positions = {
        //     [participants[0].pesuId]: [0, 1],
        // }
        // positions && Object.keys(positions).forEach(key => {
        //     const [x, y] = positions[key];
        //     matrix[x][y] = participants.find(participant => participant.pesuId === key);
        // });
        return matrix;
    }, [participants, members]);

    useEffect(() => {
        join({
            scale: 1
        });
    }, []);

    useEffect(() => {
        VoxeetSDK.filePresentation.on('started', async (file) => {
            const url = await VoxeetSDK.filePresentation.image(0, file.id);
            setPresentationImage(url);
        });
    }, []);

    console.log('GOT SEATS', seats);
    const me = participants.find((p) => p.pesuId === userId);

    return <div className={styles.room}>
        <div className="underdevelopment">Under Development</div>
        <div className={'toolbar'}>
            <button onClick={() => {
                navigate(`/spaces/${spaceId}`);
            }} className={'back'}>
                <ArrowIcon />
            </button>
            <h1>{name}</h1>
            <span style={{flex: "1 1 100%"}} />
            <div style={{ display: 'flex', alignItems: 'center', padding: '0 1rem' }}>
               <Select value={mode} onChange={value => {
                   setMode(value);
               }}>
                   {VIEW_MODE.map(v => <Select.Option value={v.id} key={v.id}>{v.label}</Select.Option>)}
                </Select> 
            </div>
            <button className={me?.audioTransmitting ? '' : 'crossed'} onClick={() => {
                if(me?.audioTransmitting){
                    VoxeetSDK.conference.stopAudio(VoxeetSDK.session.participant);
                }
                else{
                    VoxeetSDK.conference.startAudio(VoxeetSDK.session.participant);
                }
            }} ><AudioOutlined /></button>
            <button className={me?.stream ? '' : 'crossed'} onClick={() => {
                if(me.stream && me.stream.getVideoTracks().length > 0){
                    VoxeetSDK.conference.stopVideo(VoxeetSDK.session.participant);
                  }
                  else{
                    VoxeetSDK.conference.startVideo(VoxeetSDK.session.participant);
                  }
            }} ><CameraOutlined /></button>
            <button onClick={onOpenSettings}><SettingsIcon /></button>
        </div>
        {mode !== 'presentation' && <div className={styles.host}>
            <div className={styles.screen}>
                Host Here
            </div>
        </div>}
        {mode !== 'presentation' && <div className={`${styles.seats} ${mode === 'audience' ? styles.audience : ''}`}>
            {seats.map((row, i) => <div key={i} className={styles.row}>
                {row.map((participant, j) => <Seat p={participant} seatOnly={seatOnly} pos={[i, j]} onPosChange={pos => {
                    update(id, {
                        members: {
                          [userId]: {
                            pos,
                          },
                        },
                      });
                }} />)}
            </div>)}
        </div>}
        {mode === 'presentation' && <div className={`${styles.presentation}`}>
            <div className={styles.hostscreen}>
                    {!presentationImage && <div className={styles.emptymessagehost}>
                        <button>Choose a file<input type="file" onChange={async e => {
                            const file = e.target.files[0];
                            if(file.type === 'video/mp4'){
                                const uploaded = await upload(file, `room/${id}`);
                                VoxeetSDK.videoPresentation.start(uploaded.secure_url);
                            }
                            else{
                                if(file){
                                    VoxeetSDK.filePresentation.convert(file);
                                    VoxeetSDK.filePresentation.on('converted', e => {
                                        console.log('CONVERTED', e);
                                        VoxeetSDK.filePresentation.start(e);
                                    });
                                }
                            }
                        }} /></button> to start presenting or <button onClick={() => {
                            VoxeetSDK.conference.startScreenShare();
                        }}>Share Your Screen</button>
                    </div>}
                    {presentationImage && <img src={presentationImage} className={styles.presentationImage} />}
            </div>
            <div className={styles.hostvideo}>
                <UserStream name={hostParticipant.name} participant={hostParticipant} showName={hostParticipant.pesuId !== userId} />
            </div>
        </div>}
    </div>
}

export function Seat(props){
    const { id: userId } = useUserStore();
    const { p, seatOnly, pos, onPosChange } = props;
    return <div className={`${styles.seat} ${p ? styles.taken : ''}`}>
        {p && seatOnly && <span className={styles.name}>{p.name}</span>}
        {!p && seatOnly && <button className={styles.selectseat} onClick={() => {
            onPosChange(pos);
        }}>Select Seat</button>}
        {!p && !seatOnly && <span>Seat Empty</span>}
        {p && !seatOnly && <UserStream name={p.name} participant={p} showName={p.pesuId !== userId} className={styles.stream} />}
    </div>
}